export interface JournalSectionTitleFootnote {
  titleText: string
  footnoteNumber: string
  footnoteContent: string
}

export function parseJournalSectionTitleFootnote(
  titleText: string,
): JournalSectionTitleFootnote | null {
  // Temporary workaround for JSoupUtil.kt:485: only accept a title footnote when its text starts a sentence.
  const match = titleText.match(/^(.*(?:\p{L}|[.!?:;…»)]))(\d+)\s+(\p{Lu}.*)$/u)

  if (!match) {
    return null
  }

  return {
    titleText: match[1] ?? '',
    footnoteNumber: match[2] ?? '',
    footnoteContent: match[3] ?? '',
  }
}

export function journalSectionTitleWithoutFootnote(titleText: string): string {
  const footnote = parseJournalSectionTitleFootnote(titleText)

  return footnote?.titleText ?? titleText
}
